export const PRODUCT_IDS = Object.freeze({
  PUBLIC: "public",
  AGENT: "agent",
  ADMIN: "admin",
  B2C: "b2c",
  B2B: "b2b",
  PARTNER: "partner",
});

/** @typedef {typeof PRODUCT_IDS[keyof typeof PRODUCT_IDS]} ProductId */

export const PRODUCT_CONTEXT = Object.freeze({
  [PRODUCT_IDS.PUBLIC]: Object.freeze({
    defaultLocale: "he",
    layout: "PublicLocaleLayout",
  }),
  [PRODUCT_IDS.AGENT]: Object.freeze({
    defaultLocale: "he",
    layout: "AgentDashboardLayout",
    dashboardBase: "/he/dashboard",
    legacyDashboardBase: "/p/dashboard",
    legacySecurePrefix: "/p",
  }),
  [PRODUCT_IDS.ADMIN]: Object.freeze({
    defaultLocale: "he",
    layout: "AdminLayout",
    dashboardBase: "/administration",
  }),
  [PRODUCT_IDS.B2C]: Object.freeze({
    defaultLocale: "he",
    layout: "PublicLocaleLayout",
  }),
  [PRODUCT_IDS.B2B]: Object.freeze({
    defaultLocale: "he",
    layout: "AgentDashboardLayout",
  }),
  [PRODUCT_IDS.PARTNER]: Object.freeze({
    defaultLocale: "en",
    layout: "PartnerLayout",
  }),
});

export function getProductContext(productId) {
  return PRODUCT_CONTEXT[productId] || PRODUCT_CONTEXT[PRODUCT_IDS.PUBLIC];
}
